// Import des hooks React nécessaires
import { useEffect, useState } from "react";
// Import d'axios pour effectuer des requêtes HTTP
import axios from "axios";
import { logDev } from "../utils/logger.js";

/**
 * Hook personnalisé pour récupérer le rôle de l'utilisateur dans un groupe donné.
 * @param {string} groupeId - L'identifiant du groupe dont on veut connaître le rôle.
 * @returns {string|null} - Le rôle de l'utilisateur ("admin", "utilisateur", etc.) ou null si pas encore chargé.
 */

export const useAdminRole = (groupeId) => {
  // État local pour stocker le rôle actuel de l'utilisateur
  const [role, setRole] = useState(null);

  useEffect(() => {
    // Si aucun groupeId n'est fourni, on ne fait rien
    if (!groupeId) return;

    // 1️⃣ Vérifier si le rôle est déjà stocké dans le sessionStorage (cache navigateur)
    const storedRole = sessionStorage.getItem("role");
    if (storedRole) {
      logDev("[useAdminRole] rôle trouvé en cache", { groupeId, storedRole });
      
      // Si trouvé, on met à jour l'état et on évite un appel API inutile
      setRole(storedRole);
      return;
    }

    // 2️⃣ Sinon, on interroge le serveur pour connaître le rôle
    logDev("[useAdminRole] appel API rôle", { groupeId });
    axios
      .get(
        `${process.env.REACT_APP_API}/groupes/${groupeId}/role`,
        { withCredentials: true } // Inclut les cookies/session si nécessaire
      )
      .then((res) => {
        // On récupère le rôle depuis la réponse, ou "utilisateur" par défaut
        setRole(res.data?.role || "utilisateur");
        
      })
      .catch((err) => {
        logDev("[useAdminRole] erreur API, fallback utilisateur", { groupeId, err });
        setRole("utilisateur");
      });
  }, [groupeId]); // Le hook se relance si le groupeId change

  // On retourne le rôle actuel
  return role;
};
